import React, { useEffect, useState } from "react"
import { Card, Spinner } from "reactstrap"
import axios from "axios"
import Skeleton from "react-loading-skeleton"

const OnlineDrivers = ({ loading, drivers}) => {

  return (
    <div
      className="position-absolute"
      style={{
        top: "15px",
        right: "15px",
        width: "240px",
        height: "50%",
        overflowY: "auto",
        zIndex: 10,
      }}
    > 
      <Card className="p-3 shadow" style={{ borderRadius: 16 }}>
        <h6 className="fw-bold mb-3">Online drivers</h6>
        {loading ? (
          <Skeleton count={4} height={30} />
        ) : (
          <ul className="list-unstyled mb-0">
            {drivers.length === 0 ? (
              <li className="text-center text-muted">No drivers found.</li>
            ) : (
              drivers.map(driver => (
                <li
                  key={driver.user_id}
                  className="py-2"
                  style={{ borderBottom: "1px solid #eee" }}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <span
                        className="fw-semibold"
                        style={{ fontSize: "0.8rem" }}
                      >
                        {driver?.name}
                      </span>
                      {/* <span className="ms-2 text-muted small">
                        {driver.vehicles?.address || "N/A"}
                      </span> */}
                    </div>
                    <span style={{ fontSize: 16, marginLeft: 8 }}>
                      <span
                        style={{
                          color:
                            driver?.status === "free" ? "#19c37d" : "#e53935",
                          fontSize: 18,
                        }}
                      >
                        &#9679;
                      </span>
                    </span>
                  </div>
                  <div
                    className="d-flex align-items-center mt-1"
                    style={{ fontSize: "0.8rem", color: "#888" }}
                  >
                    {/* <span className="me-2">C: Ride hailing</span> */}
                    {/* <span className="mx-2" style={{ fontSize: 8 }}>
                      &#9679;
                    </span> */}
                    <span>Type: {driver?.vehicle?.type}</span>
                  </div>
                </li>
              ))
            )}
          </ul>
        )}
      </Card>
    </div>
  )
}

export default OnlineDrivers
